import React from 'react';
import clsx from 'clsx';
import {useInView} from 'react-intersection-observer';
import {useEffect} from 'react';

import {isMobile} from '../ui/animationVars';
import {useActiveModule} from '../../hooks/useActiveModule';
import {BlockDisplay} from '../../types';

type Props = {
  children?: React.ReactNode;
  className?: string;
  paddingTop?: string;
  paddingBottom?: string;
  slug?: {current: string};
  bgColor?: string | {value: string};
  blockDisplay?: BlockDisplay;
};

const ModuleWrapper: React.FC<Props> = ({
  children,
  className,
  paddingTop,
  paddingBottom,
  slug,
  bgColor,
  blockDisplay,
}: Props) => {
  // Padding Classes
  const paddingClasses = clsx([
    paddingTop === 'small' && 'pt-space-s',
    paddingTop === 'medium' && 'pt-space-m',
    paddingTop === 'large' && 'pt-space-l',
    paddingBottom === 'small' && 'pb-space-s',
    paddingBottom === 'medium' && 'pb-space-m',
    paddingBottom === 'large' && 'pb-space-l',
  ]);

  //Check if bg color is dark
  const isDark =
    bgColor === '#261F18' || bgColor === '#091C21' || bgColor === '#0a221a';

  const {ref, inView} = useInView({
    threshold: 0.3,
    triggerOnce: false,
  });

  const setActiveModule = useActiveModule();

  useEffect(() => {
    slug?.current && setActiveModule(slug?.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView, slug]);

  const {hideMobile, hideDesktop} = blockDisplay || {};
  const showBlock = !isMobile ? !hideDesktop : !hideMobile;

  if (!showBlock) return null;

  return (
    <section
      ref={ref}
      style={{
        backgroundColor: typeof bgColor === 'string' ? bgColor : bgColor?.value,
      }}
      className={`${className} ${paddingClasses} ${
        isDark && '!text-white'
      } z-1 relative w-full`}
      id={slug && slug?.current}
    >
      {children}
    </section>
  );
};

export default ModuleWrapper;
